import { client } from "../../../infrastructure/graphql/client";
import {
  GET_MONTHLY_REPORT_BY_MONTH_AND_YEAR,
  GENERATE_MONTHLY_REPORT,
} from "../../../infrastructure/graphql/aiQueries/monthlyReportQueries";

export class MonthlyReportService {
  async getMonthlyReportByMonthAndYear(year, month) {
    try {
      const result = await client.query({
        query: GET_MONTHLY_REPORT_BY_MONTH_AND_YEAR,
        variables: { year, month },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getMonthlyReportByMonthAndYear;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get monthly report error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async generateMonthlyReport(year, month) {
    try {
      const result = await client.mutate({
        mutation: GENERATE_MONTHLY_REPORT,
        variables: { year, month },
      });

      const response = result.data?.generateMonthlyReport;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Generate monthly report error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}